export const typesInputs = {
  startDate: 'start_date',
  endDate: 'end_date',
};
